export const outdatedWhimsErrorTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined) {
		if (desyncdata.indexOf('_generate_whim_buckets_for_type_and_whimset') !== -1 && desyncdata.indexOf('AttributeError: \'NoneType\' object has no attribute \'guid64\'') !== -1) {
			return {
				type: 'outdatedWhimsErrorTest',
				color: 'IndianRed',
				title: 'Outdated Wants & Fears Error',
				text: 'Broken mod is using outdated whims/wants code.',
				description: 'A broken modification adds new or edits existing whims/wants using outdated game code.<br/>' +
        'The mod creator is required to fix this error.<br/><br/>' +
        'You need to locate the PACKAGE file, in your The Sims 4 Mods folder, that could be causing this issue and remove it.<br/>' +
        'If this is a new issue, try removing the most recent mod you have installed.'
			}
		}
	}
}

// EXAMPLE
/*
<root>
    <report>
        <version>2</version>
        <sessionid>7817e6c835211c145ba05921</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4_64.15.pc</sku>
        <createtime>2099-09-17 19:31:26</createtime>
        <buildsignature>Local.Unknown.Unknown.1.99.18.1020-1.200.000.364.Release</buildsignature>
        <categoryid>__init__.py:195</categoryid>
        <desyncid>7817e6c835211c145ba05921</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>
Traceback (most recent call last):
  File "T:\InGame\Gameplay\Scripts\Server\sims\masked\v170i\zone_tick.py", line 121, in _on_zone_update_event
  File "T:\InGame\Gameplay\Scripts\Server\sims\masked\v170i\zone_tick.py", line 69, in update
  File ".\WickedWhims_v170i\wickedwhims\sex\integral\sex_handlers\active_sex\active_sex_handlers.py", line 124, in _update_sex_instances_on_zone_update
  File ".\WickedWhims_v170i\wickedwhims\sex\integral\sex_handlers\active_sex\active_sex_handlers.py", line 142, in update_active_sex_instances
  File ".\WickedWhims_v170i\wickedwhims\sex\integral\sex_handlers\active_sex\active_sex_instance_tick.py", line 276, in update
  File ".\WickedWhims_v170i\wickedwhims\sex\integral\sex_handlers\active_sex\active_sex_instance_tick.py", line 110, in _update
  File ".\WickedWhims_v170i\wickedwhims\sex\integral\sex_handlers\active_sex\active_sex_instance_tick.py", line 620, in update
  File ".\WickedWhims_v170i\wickedwhims\sex\integral\sex_handlers\active_sex\utils\snapshot.py", line 118, in update_sim_sex_snapshot_statistic
  File ".\WickedWhims_v170i\turbolib2\wrappers\sim\super_sim.py", line 73, in _safe_sim_info_wrapper
  File ".\WickedWhims_v170i\turbolib2\wrappers\sim\statistics.py", line 22, in set_statistic_value
  File ".\WickedWhims_v170i\turbolib2\services\statistics_service.py", line 83, in set_statistic_value
  File "T:\InGame\Gameplay\Scripts\Server\statistics\commodity_tracker.py", line 71, in set_value
  File "T:\InGame\Gameplay\Scripts\Server\statistics\base_statistic_tracker.py", line 507, in set_value
  File "T:\InGame\Gameplay\Scripts\Server\statistics\commodity.py", line 1957, in set_value
  File "T:\InGame\Gameplay\Scripts\Server\statistics\continuous_statistic.py", line 324, in set_value
  File "T:\InGame\Gameplay\Scripts\Server\statistics\base_statistic.py", line 308, in set_value
  File "T:\InGame\Gameplay\Scripts\Server\statistics\base_statistic.py", line 323, in _notify_change
  File "T:\InGame\Gameplay\Scripts\Server\statistics\continuous_statistic.py", line 750, in _update_callback_listeners
  File "T:\InGame\Gameplay\Scripts\Server\statistics\base_statistic_listener.py", line 76, in trigger_callback
  File "T:\InGame\Gameplay\Scripts\Server\statistics\commodity.py", line 1292, in _update_state_down
  File "T:\InGame\Gameplay\Scripts\Server\statistics\commodity.py", line 1583, in _set_state
  File "T:\InGame\Gameplay\Scripts\Server\interactions\utils\loot.py", line 551, in apply_to_resolver
  File "T:\InGame\Gameplay\Scripts\Server\interactions\utils\loot.py", line 548, in apply_to_resolver
  File "T:\InGame\Gameplay\Scripts\Server\interactions\utils\loot_basic_op.py", line 285, in apply_to_resolver
  File "T:\InGame\Gameplay\Scripts\Server\whims\whim_loot_ops.py", line 90, in _apply_to_subject_and_target
  File "T:\InGame\Gameplay\Scripts\Server\whims\whim_loot_ops.py", line 44, in __call__
  File "T:\InGame\Gameplay\Scripts\Server\whims\whims_tracker.py", line 720, in refresh_whims
  File "T:\InGame\Gameplay\Scripts\Server\whims\whims_tracker.py", line 1417, in _populate_slots
  File "T:\InGame\Gameplay\Scripts\Server\whims\whims_tracker.py", line 1274, in _try_populate_slot_from_whimset
  File "T:\InGame\Gameplay\Scripts\Server\whims\whims_tracker.py", line 1354, in _generate_whim_buckets_for_type_and_whimset
AttributeError: 'NoneType' object has no attribute 'guid64'
</desyncdata>
    </report>
</root>
*/



// WEBPACK FOOTER //
// ./src/tests/mods/outdatedWhimsErrorTest.js